<div class="forgot-password-form">
  <h1 class="forgot-password-form__title">
    {{ ("resetPassword" | i18n) || "reset password" }}
  </h1>

  <form
    class="forgot-password-form__form"
    (ngSubmit)="forgotPassword()">
    <mat-form-field>
      <mat-label>{{ ("email" | i18n) || "Email" }}</mat-label>
      <input
        matInput
        [(ngModel)]="email"
        type="email"
        autofocus
        name="user"
        data-cy="forgot-password-email" />
    </mat-form-field>

    <button
      mat-button
      color="primary"
      type="submit"
      name="login"
      class="mat-button-block"
      data-cy="forgot-password-submit"
      value="Login">
      {{ ("reset" | i18n) || "reset" | uppercase }}
    </button>
  </form>
  <div class="forgot-password-form__additional-content">
    <a
      mat-button
      class="forgot-password-form__back-to-login"
      [routerLink]="['/login']">
      <mat-icon
        class="forgot-password-form__back_icon"
        svgIcon="chevron-left"></mat-icon>
      {{ ("goToLogin" | i18n) || "go to login" | uppercase }}
    </a>
  </div>
</div>
